/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseDataResponse_FeedbackApplicationResponse_ } from '../models/BaseDataResponse_FeedbackApplicationResponse_';
import type { BaseListDataResponse_FeedbackApplicationResponse_ } from '../models/BaseListDataResponse_FeedbackApplicationResponse_';
import type { CreateUserFeedbackRequest } from '../models/CreateUserFeedbackRequest';
import type { FeedbackApplicationStatus } from '../models/FeedbackApplicationStatus';
import type { UpdateFeedbackApplicationStatusRequest } from '../models/UpdateFeedbackApplicationStatusRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FeedbackHrOneOnOneService {
    /**
     * List Hr One On One Applications
     * Получение списка заявок на обратную связь HR 1-on-1 с фильтрацией
     * @param status Фильтр по статусу
     * @param userId Фильтр по ID пользователя
     * @param userSearch Поиск по username, email или full_name (частичное совпадение)
     * @param limit Лимит
     * @param offset Смещение
     * @returns BaseListDataResponse_FeedbackApplicationResponse_ Successful Response
     * @throws ApiError
     */
    public static listHrOneOnOneApplicationsApiFeedbackHrOneOnOneGet(
        status?: (FeedbackApplicationStatus | null),
        userId?: (string | null),
        userSearch?: (string | null),
        limit: number = 50,
        offset?: number,
    ): CancelablePromise<BaseListDataResponse_FeedbackApplicationResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/feedback/hr-one-on-one',
            query: {
                'status': status,
                'user_id': userId,
                'user_search': userSearch,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                401: `Code: authentication_error`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Create My Hr One On One Application
     * Создание заявки на ОЗ с HR от имени текущего пользователя
     * @param requestBody
     * @returns BaseDataResponse_FeedbackApplicationResponse_ Successful Response
     * @throws ApiError
     */
    public static createMyHrOneOnOneApplicationApiFeedbackHrOneOnOneMePost(
        requestBody: CreateUserFeedbackRequest,
    ): CancelablePromise<BaseDataResponse_FeedbackApplicationResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/feedback/hr-one-on-one/me',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Code: authentication_error`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * List My Hr One On One Applications
     * Получение списка своих заявок на ОЗ с HR
     * @param status Фильтр по статусу
     * @param limit Лимит
     * @param offset Смещение
     * @returns BaseListDataResponse_FeedbackApplicationResponse_ Successful Response
     * @throws ApiError
     */
    public static listMyHrOneOnOneApplicationsApiFeedbackHrOneOnOneMeGet(
        status?: (FeedbackApplicationStatus | null),
        limit: number = 50,
        offset?: number,
    ): CancelablePromise<BaseListDataResponse_FeedbackApplicationResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/feedback/hr-one-on-one/me',
            query: {
                'status': status,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                401: `Code: authentication_error`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Get My Hr One On One Application
     * Получение своей заявки на ОЗ с HR по ID
     * @param applicationId
     * @returns BaseDataResponse_FeedbackApplicationResponse_ Successful Response
     * @throws ApiError
     */
    public static getMyHrOneOnOneApplicationApiFeedbackHrOneOnOneMeApplicationIdGet(
        applicationId: string,
    ): CancelablePromise<BaseDataResponse_FeedbackApplicationResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/feedback/hr-one-on-one/me/{application_id}',
            path: {
                'application_id': applicationId,
            },
            errors: {
                401: `Code: authentication_error`,
                404: `Code: feedback_application_not_found`,
                422: `Validation Error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Get Hr One On One Application
     * Получение заявки на обратную связь HR 1-on-1 по ID
     * @param applicationId
     * @returns BaseDataResponse_FeedbackApplicationResponse_ Successful Response
     * @throws ApiError
     */
    public static getHrOneOnOneApplicationApiFeedbackHrOneOnOneApplicationIdGet(
        applicationId: string,
    ): CancelablePromise<BaseDataResponse_FeedbackApplicationResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/feedback/hr-one-on-one/{application_id}',
            path: {
                'application_id': applicationId,
            },
            errors: {
                401: `Code: authentication_error`,
                404: `Code: feedback_application_not_found`,
                422: `Validation Error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Update Hr One On One Application Status
     * Обновление статуса заявки на обратную связь HR 1-on-1
     * @param applicationId
     * @param requestBody
     * @returns BaseDataResponse_FeedbackApplicationResponse_ Successful Response
     * @throws ApiError
     */
    public static updateHrOneOnOneApplicationStatusApiFeedbackHrOneOnOneApplicationIdStatusPut(
        applicationId: string,
        requestBody: UpdateFeedbackApplicationStatusRequest,
    ): CancelablePromise<BaseDataResponse_FeedbackApplicationResponse_> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/feedback/hr-one-on-one/{application_id}/status',
            path: {
                'application_id': applicationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Code: authentication_error`,
                404: `Code: feedback_application_not_found`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
}
